import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Routes from '@/router/Routes';
import Middleware from '@/router/middleware/index';
import { useAuthContext } from '@/context/AuthContext';

/**
 * Middleware that checks if the company admin's email is verified
 * Redirects to company login if email is not confirmed
 */
const AuthCompanyVerified: FC = () => {
  const { session, isLoading } = useAuthContext();

  const isEmailVerified = session?.user?.email_confirmed_at != null;

  return (
    <Middleware isLoading={isLoading}>
      {isEmailVerified ? <Outlet /> : <Navigate to={Routes.COMPANY__LOGIN} />}
    </Middleware>
  );
};

export default AuthCompanyVerified;

